import { createActions, createReducer } from 'reduxsauce'

import FonteService from '../servicos/FonteService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaFonteInicio: [],
    buscaFonteSucesso: ['fonte'],
    buscaFonteErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: '',
}

// Ação para busca completa
Creators.buscaFontes = () => {
    return dispatch => {
        dispatch(Creators.buscaFonteInicio())
        let serv = new FonteService()
        return serv
            .getFonte()
            .then(response => dispatch(Creators.buscaFonteSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaFonteErro(error)))
    }
}

const buscaFonteInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaFonteErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaFonteSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, nome: action.fonte.nomeFonte, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_FONTE_INICIO]: buscaFonteInicio,
    [Types.BUSCA_FONTE_ERRO]: buscaFonteErro,
    [Types.BUSCA_FONTE_SUCESSO]: buscaFonteSucesso,
})
